import { useEffect, useRef } from 'react';

export default (channel) => {
  const broadcast = useRef(null);

  useEffect(() => {
    const bc = new BroadcastChannel(channel);
    broadcast.current = bc;

    return () => {
      bc.close();
    };
  }, [channel]);

  return broadcast.current;
};
